// Typography configuration for MenuMaster

export const typography = {
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  h1: {
    fontSize: '3rem',
    fontWeight: 800, // ExtraBold
    lineHeight: 1.1,
    letterSpacing: '-0.03em', // tighter
    fontFamily: '"Space Grotesk", "Inter", sans-serif',
  },
  h2: {
    fontSize: '2.25rem',
    fontWeight: 800, // ExtraBold
    lineHeight: 1.2,
    letterSpacing: '-0.025em',
    fontFamily: '"Space Grotesk", "Inter", sans-serif',
  },
  h3: {
    fontSize: '1.75rem',
    fontWeight: 700, // Bold
    lineHeight: 1.3,
    letterSpacing: '-0.02em',
    fontFamily: '"Space Grotesk", "Inter", sans-serif',
  },
  h4: {
    fontSize: '1.375rem',
    fontWeight: 700,
    lineHeight: 1.4,
    letterSpacing: '-0.015em',
  },
  h5: {
    fontSize: '1.125rem',
    fontWeight: 600,
    lineHeight: 1.5,
    letterSpacing: '-0.01em',
  },
  h6: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.5,
    letterSpacing: '-0.005em',
  },
  body1: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.7, // more generous line height
  },
  body2: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.6,
  },
  button: {
    fontSize: '0.875rem',
    fontWeight: 600,
    textTransform: 'none' as const,
    letterSpacing: '0.01em',
  },
  caption: {
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: 1.4,
  },
  overline: {
    fontSize: '0.6875rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase' as const,
  },
};

export const displayFont = '"Space Grotesk", sans-serif';
